module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "2groupOfPeople.9bf9a387.svg";